import { certifications, achievements } from "../data/content";
import { Award, Trophy } from "lucide-react";
import { motion } from "framer-motion";

export default function Certifications() {
  return (
    <section data-testid="certifications-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16">
        <div>
          <div className="overline">Recognition</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-3 mb-10" style={{ color: "var(--primary)" }}>
            Notable achievements
          </h2>
          <ul className="space-y-5">
            {achievements.map((a, i) => (
              <motion.li
                key={i}
                className="relative pl-6 py-5"
                style={{ borderLeft: "2px solid var(--accent-strong)", backgroundColor: "var(--surface)" }}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
                whileHover={{ x: 4, boxShadow: "0 6px 30px rgba(15,40,35,0.07)" }}
                data-testid={`achievement-${i}`}
              >
                <div className="flex gap-3 items-start pr-5">
                  <Trophy size={18} style={{ color: "var(--accent-strong)" }} className="mt-1 shrink-0" />
                  <p className="text-base md:text-lg leading-relaxed font-serif" style={{ color: "var(--primary)" }}>
                    {a}
                  </p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
        <div>
          <div className="overline">Credentials</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-3 mb-10" style={{ color: "var(--primary)" }}>
            Certifications &amp; training
          </h2>
          <ul className="grid gap-3">
            {certifications.map((c, i) => (
              <motion.li
                key={i}
                className="group flex items-start gap-4 p-4 transition-colors"
                style={{ backgroundColor: "var(--bg)", border: "1px solid var(--border-soft)" }}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-30px" }}
                transition={{ duration: 0.35, delay: i * 0.05 }}
                whileHover={{ y: -2, backgroundColor: "var(--surface)" }}
                data-testid={`cert-${i}`}
              >
                <div className="shrink-0 px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-widest" style={{ color: "var(--accent-strong)", border: "1px solid var(--accent-strong)" }}>
                  {c.year}
                </div>
                <div className="flex-1 flex items-start gap-2">
                  <Award size={16} style={{ color: "var(--primary)" }} className="mt-0.5 shrink-0" />
                  <span className="text-sm md:text-base" style={{ color: "var(--text-primary)" }}>{c.label}</span>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
